import { useParams } from 'react-router';
import { IImpersonationContext } from '../../../extViewmodels';
import {
	AdminDrawerToolbar,
	AppDrawerToolbarButton,
	SideDrawer,
	StickyAppDrawerContent,
} from '../../../web/components-v2/Drawer/AppDrawer';
import { SparklesIcon } from '../../../web/components/svgs/icons/SparklesIcon';
import { AdminAppAssistantChat } from '../../../web/containers/templates/AssistantChat';
import { DataRefresh } from '../../components/DataRefresh';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';

export const AdminAccountDataRefreshPage = () => {
	const params = useParams<{ accountId: string }>();
	const impersonationContext: IImpersonationContext = { account: { id: params.accountId } };
	return (
		<AdminDashboardPageLayout
			sidebarChildren={
				<SideDrawer>
					<StickyAppDrawerContent value='ai-assistant'>
						<AdminAppAssistantChat impersonationContext={impersonationContext} />
					</StickyAppDrawerContent>
					<AdminDrawerToolbar>
						<AppDrawerToolbarButton value='ai-assistant'>
							<SparklesIcon />
						</AppDrawerToolbarButton>
					</AdminDrawerToolbar>
				</SideDrawer>
			}
		>
			<DataRefresh />
		</AdminDashboardPageLayout>
	);
};
